import React, { useState, useEffect } from 'react';

// Banner görsellerini import ediyoruz
import banner1 from '../../assets/images/banner/banner-1.jpg';
import banner2 from '../../assets/images/banner/banner-2.jpg';
import banner3 from '../../assets/images/banner/banner-3.jpg';
import banner4 from '../../assets/images/banner/banner-4.jpg';

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Ev Taşımacılığında Güvenin Adresi",
      subtitle: "Eşyalarınızı yeni yuvanıza sorunsuz taşıyoruz.",
      image: banner1,
    },
    {
      title: "Ofisiniz Bizimle Hızla Yerleşir",
      subtitle: "İş yerinizi kesintisiz taşıma ile yeni adresine ulaştırıyoruz.",
      image: banner2,
    },
    {
      title: "Asansörlü Taşıma ile Kolaylık",
      subtitle: "Yüksek katlara hızlı ve güvenli çözümler sunuyoruz.",
      image: banner3,
    },
    {
      title: "Şehirler Arası Sorunsuz Nakliyat",
      subtitle: "Türkiye'nin her yerine güvenilir taşımacılık.",
      image: banner4,
    }
  ];

  // Otomatik slider geçişi için
  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000);

    return () => clearTimeout(timer);
  }, [currentSlide, slides.length]);

  // Önceki slayta geçiş
  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + slides.length) % slides.length);
  };

  // Sonraki slayta geçiş
  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  return (
    <div className="relative w-full h-[500px] overflow-hidden">
      {/* Placeholder notunu kaldırıyoruz */}

      {/* Slider içeriği */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            currentSlide === index ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Görsel arkaplan */}
          <img 
            src={slide.image} 
            alt={slide.title}
            className="w-full h-full object-cover"
            loading={index === 0 ? "eager" : "lazy"}
          />

          {/* Overlay ve İçerik */}
          <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center text-white text-center p-4">
            <h2 className="text-4xl font-bold mb-4">{slide.title}</h2>
            <p className="text-xl mb-8">{slide.subtitle}</p>
            <div className="flex space-x-4">
              <a 
                href="tel:+905393801469" 
                className="bg-primary hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md transition-colors"
              >
                Hemen Ara
              </a>
              <a 
                href="https://wa.me/905393801469?text=Merhaba%20Cihangir%20Nakliyat,%20nakliyat%20hizmetleriniz%20hakkında%20bilgi%20almak%20istiyorum." 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-md transition-colors flex items-center"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      ))}

      {/* Navigasyon okları */}
      <button
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20 bg-white bg-opacity-30 hover:bg-opacity-50 text-white p-2 rounded-full"
        onClick={prevSlide}
        aria-label="Önceki Slayt"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 bg-white bg-opacity-30 hover:bg-opacity-50 text-white p-2 rounded-full"
        onClick={nextSlide}
        aria-label="Sonraki Slayt"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Gösterge Noktaları */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full ${
              currentSlide === index ? 'bg-primary' : 'bg-white bg-opacity-50'
            }`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Slayt ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Banner; 